/* tslint:disable */
/* eslint-disable */
/**
 * Vercasa API
 * Vercasa API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';

/**
 * 
 * @export
 * @interface MyTeamResponse
 */
export interface MyTeamResponse {
    /**
     * 
     * @type {string}
     * @memberof MyTeamResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MyTeamResponse
     */
    name: string;
    /**
     * 
     * @type {User}
     * @memberof MyTeamResponse
     */
    manager: User;
    /**
     * 
     * @type {Array<User>}
     * @memberof MyTeamResponse
     */
    members: Array<User>;
}

/**
 * Check if a given object implements the MyTeamResponse interface.
 */
export function instanceOfMyTeamResponse(value: object): value is MyTeamResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('manager' in value) || value['manager'] === undefined) return false;
    if (!('members' in value) || value['members'] === undefined) return false;
    return true;
}

export function MyTeamResponseFromJSON(json: any): MyTeamResponse {
    return MyTeamResponseFromJSONTyped(json, false);
}

export function MyTeamResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MyTeamResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'manager': UserFromJSON(json['manager']),
        'members': ((json['members'] as Array<any>).map(UserFromJSON)),
    };
}

export function MyTeamResponseToJSON(json: any): MyTeamResponse {
    return MyTeamResponseToJSONTyped(json, false);
}

export function MyTeamResponseToJSONTyped(value?: MyTeamResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'manager': UserToJSON(value['manager']),
        'members': ((value['members'] as Array<any>).map(UserToJSON)),
    };
}

